import { TextField } from "@mui/material";
import { useState } from "react";

import { Shared_FormTemplate_QuestionTypeTextFragment } from "../fragments/fragmentsTypes.generated";
import { NarrowedFormField } from "../types";

type Props = {
    disabled?: boolean;
    field: NarrowedFormField<Shared_FormTemplate_QuestionTypeTextFragment>;
    value?: string | null;
    onChange?: (value: string) => void;
};

export default function QuestionText({ disabled, field, value, onChange }: Props) {
    const [isFocused, setIsFocused] = useState<boolean>(false);

    return (
        <TextField
            helperText={field.description}
            placeholder={field.placeholder || undefined}
            label={field.name}
            multiline={field.type.multiline}
            minRows={field.type.multiline ? 4 : 1}
            value={value}
            onChange={e => onChange?.(e.target.value)}
            disabled={disabled}
            required={field.isRequired ?? false}
            fullWidth
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}
            slotProps={{
                input: {
                    readOnly: disabled || !onChange,
                },
                inputLabel: {
                    shrink: !!(isFocused || value || field.placeholder),
                },
            }}
        />
    );
}
